__turbopack_context__.v({
  "center": "styles-module__ET_N4G__center",
  "featuredSubtitle": "styles-module__ET_N4G__featuredSubtitle",
  "fold": "styles-module__ET_N4G__fold",
  "foldContent": "styles-module__ET_N4G__foldContent",
  "foldSubheading": "styles-module__ET_N4G__foldSubheading",
  "foldTitle": "styles-module__ET_N4G__foldTitle",
  "foldTitleWithFeaturedSubtitle": "styles-module__ET_N4G__foldTitleWithFeaturedSubtitle",
  "left": "styles-module__ET_N4G__left",
});
